var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 20L2 20C0.89543 20 0 19.1046 0 18L0 4C0 2.89543 0.89543 2 2 2L4 2V0L6 0V2L12 2V0L14 0V2L16 2C17.1046 2 18 2.89543 18 4L18 18C18 19.1046 17.1046 20 16 20ZM2 8L2 18L16 18L16 8L2 8ZM2 4L2 6L16 6V4L2 4ZM14 16H12V14H14V16ZM10 16H8V14H10V16ZM6 16L4 16V14L6 14V16ZM14 12H12V10H14V12ZM10 12H8V10H10V12ZM6 12L4 12V10L6 10V12Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.c5a65e756182a478e8777b4883c2232b.svg";
export { ForwardRef as ReactComponent };